import React from 'react';
import propTypes from 'prop-types';
import classNames from 'classnames';

import {
  aggregateThumbnailConfig
} from 'dataviz/config/map';

import VizMap from 'dataviz/VizMap';

const baseString = 'vra-viz-thumbnail';
const classString = classNames({
  [`${baseString}`]: true
});
const VizThumbnail = ({
  config,
  zones
}) => (
  <section className={classString}>
    <VizMap
      config={aggregateThumbnailConfig(config)}
      zones={zones}
    />
  </section>
);
VizThumbnail.propTypes = {
  config: propTypes.object,
  zones: propTypes.object
};
export default VizThumbnail;
